"use client";

import React from "react";
import s from "../styles";

export default function CarDetailsArea({ data }) {
  const getHandleText = (handleValue) => {
    if (handleValue === "1") return "右";
    if (handleValue === "2") return "左";
    return "未設定";
  };

  const handleText = getHandleText(data?.request.Sharyo_Handle);

  return (
    <s.DetailTable>
      <s.DetailCaption>車輌情報</s.DetailCaption>
      <tbody>
        <tr>
          <s.DetailTh style={{ textAlign: "right" }} scope="row">
            型式指定
          </s.DetailTh>
          <s.DetailTd>{data?.request.Katashiki}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>類別区分</s.DetailTh>
          <s.DetailTd>{data?.request.Ruibetsu}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>車台番号</s.DetailTh>
          <s.DetailTd>{data?.request.Shadaibango}</s.DetailTd>
          <s.DetailTh>&nbsp;</s.DetailTh>
          <s.DetailTd>&nbsp;</s.DetailTd>
        </tr>
        <tr>
          <s.DetailTh style={{ textAlign: "right" }} scope="row">
            メーカー
          </s.DetailTh>
          <s.DetailTd>{data?.request.MakerName}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>車名</s.DetailTh>
          <s.DetailTd>{data?.request.CarName}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>車輌型式</s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_Katashiki}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>グレード</s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_Grade}</s.DetailTd>
        </tr>
        <tr>
          <s.DetailTh style={{ textAlign: "right" }} scope="row">
            エンジン型式
          </s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_EngineKatashiki}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>排気量</s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_Haikiryo}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>年式</s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_Nenshiki}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>燃料種別</s.DetailTh>
          <s.DetailTd>{data?.request.Ekubun}</s.DetailTd>
        </tr>
        <tr>
          <s.DetailTh style={{ textAlign: "right" }} scope="row">
            シフト方式
          </s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_TransMission}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>駆動方式</s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_KudouHoushiki}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>カラー番号</s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_ColorNo}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>カラー名称</s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_Color}</s.DetailTd>
        </tr>
        <tr>
          <s.DetailTh style={{ textAlign: "right" }} scope="row">
            トリム番号
          </s.DetailTh>
          <s.DetailTd>{data?.request.Sharyo_TrimNo}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }} scope="row">
            ハンドル
          </s.DetailTh>
          <s.DetailTdLeft>
            {data?.request.Sharyo_Handle === "2" && <s.RedText>*** {handleText} ***</s.RedText>}
            {data?.request.Sharyo_Handle !== "2" && <>{handleText}</>}
          </s.DetailTdLeft>
          <s.DetailTh>&nbsp;</s.DetailTh>
          <s.DetailTd>&nbsp;</s.DetailTd>
          <s.DetailTh>&nbsp;</s.DetailTh>
          <s.DetailTd>&nbsp;</s.DetailTd>
        </tr>
        {/* /// @@@車輌検索コメントアウト
        <tr>
          <s.DetailTh style={{ textAlign: "right" }} scope="row">
            装備情報
          </s.DetailTh>
          <s.DetailTd>{data?.request?.Sharyo_Remark_Nm}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>ボディタイプ</s.DetailTh>
          <s.DetailTd>{data?.request?.Sharyo_Body_Nm}</s.DetailTd>
          <s.DetailTh style={{ textAlign: "right" }}>車型グループ</s.DetailTh>
          <s.DetailTd>{data?.request?.Sharyo_Sya_Type}</s.DetailTd>
          <s.DetailTh>&nbsp;</s.DetailTh>
          <s.DetailTd>&nbsp;</s.DetailTd>
        </tr>
        */}
      </tbody>
    </s.DetailTable>
  );
}
